import clsx from 'clsx'
import moment from 'moment'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {isEmpty} from '../../../../helpers/utils'

const useStyles = makeStyles(infoStyles)

export default function WriteComments ({context}) {

  const {quizAssignmentToModify: assignment, translate} = context
  const hours = Math.floor(assignment.duration / 3600)
  const minutes = assignment.duration % 3600 / 60
  const classes = useStyles()

  return (
      <Box className={classes.root}>
        <Box className={clsx(classes.label, "group")}>{translate('group_label')}</Box>
        <Box className={clsx(classes.container, "group")}>
          <Box className={classes.group}>
            {assignment.groupName}
          </Box>
        </Box>
        <Box className={classes.dateDuration}>
        <Box className={classes.dates}>
          <Box className="from">
            <Box className={classes.label}>{translate("start")}</Box>
            <Box className={classes.datePicker}>
              <Box className="date-input">
                <FontAwesomeIcon icon={faCalendarAlt} />
                {moment(assignment.start).format("MM/DD/yyyy h:mm a")}
              </Box>
            </Box>
          </Box>
          <div className="to">
            <Box className={classes.label}>{translate("end")}</Box>
            <Box className={classes.datePicker}>
              <Box className="date-input">
                <FontAwesomeIcon icon={faCalendarAlt} />
                {moment(assignment.finish).format("MM/DD/yyyy h:mm a")}
              </Box>
            </Box>
          </div>
        </Box>
        <Box className={classes.duration}>
          <div className="hours">
            <Box className={classes.label}>{translate("hours")}</Box>
            <div className={classes.durationInput}>
              <input type="text" value={hours} readOnly/>
            </div>
          </div>
          <div className="minutes">
            <Box className={classes.label}>{translate("minutes")}</Box>
            <div className={classes.durationInput}>
              <input type="text" value={minutes} readOnly />
            </div>
          </div>
        </Box>
        </Box>
        {!isEmpty(assignment.comments) && (
          <React.Fragment>
            <Box className={clsx(classes.label, "comments")}>{translate('comment')}</Box>
            <Box className={classes.comments}>
              <textarea value={assignment.comments} readOnly/>
            </Box>
          </React.Fragment>
        )}
      </Box>
    )
}

function infoStyles(theme) {
  return {
    root: {
      display: 'flex',
      flexGrow: 1, flexDirection: 'column',
      padding: 0,
      overflow: 'hidden',
    },
    comments: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflowY: 'auto',
      "& textarea": {
        flexGrow: 1,
        resize: 'none'
      }
    },
    label: {
      marginBottom: 5,
      "&.comments": {
        marginTop: 20
      }
    },
    dateDuration: {
      display: 'flex',
      marginTop: 20,
    },
    dates: {
      display: 'flex',
    },
    container: {
      "&.group": {
        display: 'flex'
      }
    },
    group: {
      border: 'solid 1px #4F576E',
      borderRadius: 2,
      minWidth: 372,
      padding: 5
    },
    datePicker: {
      marginRight: 20,
      "& .date-input": {
        border: 'solid 1px #4F576E',
        borderRadius: 2,
        padding: 5
      },
      "& svg": {
        marginRight: 5
      }
    },
    durationInput: {
      marginRight: 20,
      "& input": {
        padding: '3px 5px',
        border: 'solid 1px #4F576E',
        borderRadius: 2,
        fontSize: '1rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: '0.00938em'
      }
    },
    duration: {
      display: 'flex'
    }
  }
}
